import React from 'react'

import { Page } from 'components'

export const UserDetail = () => <Page>User detail</Page>

export default UserDetail
